import * as React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { useHistory } from 'react-router-dom';

const Styled = {
  Root: styled(Box)( () => ({
    marginTop: '2em',
    position: 'relative',
  })),
  Card: styled(Box)({
    margin: '0 auto',
    backgroudColor: 'transparent',
    minWidth: '336px',
    width: '77%',
    ['@media (max-width:768px)']: {
      width: '97%'
    },
    ['@media (max-width:350px)']: {
      width: '290px',
      minWidth: 'unset'
    },
  }),
  CardContent: styled(Box)({
    marginBottom: '3em',
    padding: '2em',
    '& i': {
      fontSize: '2rem',
      verticalAlign: 'text-bottom'
    },
    '& .career-center-cta': {
      width: '100%',
      maxWidth: '266px',
      marginTop: '26px'
    }
  }),
  ContentTitle: styled(Typography)({
    marginBottom: '16px',
    '& span': {
      marginRight: '14px'
    }
  })
};

interface CardSectionProps {
  icon: string;
  title: string;
  text: string;
  btnText: string;
  href: string;
}

const CardSection = ({
  icon,
  title,
  text,
  btnText,
  href
}: CardSectionProps): JSX.Element => {
  const history = useHistory();
  const handleCtaClick = (): void => {
    history.push(href);
  };

  return (
    <Styled.CardContent data-testid="card-section">
      <Styled.ContentTitle variant="EC_TYPE_LG">
        <span>
          <i className={icon} />
        </span>
        {title}
      </Styled.ContentTitle>
      <Typography variant="EC_TYPE_BASE">{text}</Typography>
      <Button
        variant="contained"
        className="career-center-cta"
        onClick={handleCtaClick}
        fullWidth
      >
        {btnText}
      </Button>
    </Styled.CardContent>
  );
};

const CareerCenter: React.FC = () => {

  return (
    <Styled.Root
      data-testid="career-center-root-container"
    >
      <Styled.Card>
        <CardSection
          icon="ri-file-user-line"
          title="Manage Your Profile"
          text="Keep your profile up-to-date so that you're matched to employers that meet your lifestyle needs and career goals."
          btnText="Candidate Profile"
          href={'/candidate/profile-setup'}
        />
        <CardSection
          icon="ri-briefcase-fill"
          title="Find Your Next Job"
          text="Looking for a new opportunity? Check out EConnect and start applying to jobs you think would be a good match."
          btnText="See EConnect"
          href="/econnect"
        />
      </Styled.Card>
    </Styled.Root>
  );
};

export default CareerCenter;
